module.exports = __webpack_public_path__ + "img/offline-heading.2707c990.svg";